// All Brands directory — checkbox-driven A-Z filter + live search over a fully
// server-rendered brand list. Ported from RDI-Shopify's assets/brands-component.js
// (same interaction model: one letter checked at a time, unchecking / "All Brands"
// resets, search is a plain substring match over the pre-rendered DOM) — no fetch,
// no re-render, just showing/hiding what Liquid already rendered.
(() => {
  if (window.customElements.get('dev-brands-directory')) return;

  window.customElements.define(
    'dev-brands-directory',
    class extends HTMLElement {
      #initialized = false;

      constructor() {
        super();
      }

      // <lazy-script> constructs this element before moving its deferred
      // children in, so querying DOM here in the constructor (as a first
      // attempt did) always finds an empty element — nothing to bind to.
      // connectedCallback fires once those children are actually present.
      connectedCallback() {
        if (this.#initialized) return;
        this.#initialized = true;
        this.#init();
      }

      #init() {
        this.letterInputs = this.querySelectorAll('[data-brands-letters] input[type="checkbox"]');
        this.groups = this.querySelectorAll('[data-brands-group]');
        this.countEl = this.querySelector('[data-brands-count]');
        this.allButton = this.querySelector('[data-brands-all]');
        this.searchInput = this.querySelector('[data-brands-search]');
        this.totalCount = this.querySelectorAll('[data-brand-name]').length;
        this.#updateCount(this.totalCount);

        this.letterInputs.forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
              this.letterInputs.forEach((other) => {
                if (other !== checkbox) other.checked = false;
              });
              this.groups.forEach((group) => {
                group.classList.toggle('hidden', group.dataset.brandsGroup !== checkbox.value);
              });
              const shown = this.querySelectorAll(
                `[data-brands-group="${checkbox.value}"] [data-brand-name]`
              ).length;
              this.#updateCount(shown);
            } else {
              this.groups.forEach((group) => group.classList.remove('hidden'));
              this.#updateCount(this.totalCount);
            }
          });
        });

        this.allButton?.addEventListener('click', () => {
          this.letterInputs.forEach((checkbox) => (checkbox.checked = false));
          this.groups.forEach((group) => {
            group.classList.remove('hidden');
            group.classList.remove('is-search-empty');
          });
          if (this.searchInput) this.searchInput.value = '';
          this.querySelectorAll('[data-brand-name]').forEach((item) => item.classList.remove('is-filtered-out'));
          this.#updateCount(this.totalCount);
        });

        this.searchInput?.addEventListener('input', () => {
          const query = this.searchInput.value.trim().toLowerCase();
          let visible = 0;
          this.querySelectorAll('[data-brand-name]').forEach((item) => {
            const matches = item.dataset.brandName.toLowerCase().includes(query);
            item.classList.toggle('is-filtered-out', !matches);
            if (matches) visible++;
          });
          // A letter group with no surviving items would otherwise still show
          // its header + divider with nothing underneath — hide the whole
          // group when the search wipes out everything inside it.
          this.groups.forEach((group) => {
            const hasVisibleItem = group.querySelector('[data-brand-name]:not(.is-filtered-out)');
            group.classList.toggle('is-search-empty', !hasVisibleItem);
          });
          this.#updateCount(visible);
        });
      }

      #updateCount(count) {
        if (this.countEl) this.countEl.textContent = count;
      }
    }
  );
})();
